<template>
  <ApplicationReview
    :declarer="declarer"
    :sections="sections"
    :fields="fields"
    :alerts="alerts"
    :hasAttemptToSubmit="hasAttemptToSubmit"
    @isSectionDisabled="isSectionDisabled"
    @isSectionVisible="isSectionVisible"
    @setFinalDeclarer="setFinalDeclarer"
    @clearFinalDeclarer="clearFinalDeclarer"
  />
</template>

<script>
import ApplicationReview from '@/components/application/ApplicationReview.vue'

export default {
  name: 'ContainerApplicationReview',
  components: {
    ApplicationReview
  },
  computed: {
    declarer() {
      // The declarer will be whoever is defined as completing the application. We also only want
      // to use them if they have their family and given name defined
      return this.$store.state.application.client
    },
    sections() {
      return this.$store.state.sections
    },
    fields() {
      return this.$store.state.fields
    },
    alerts() {
      return this.$store.state.alerts || []
    },
    hasAttemptToSubmit() {
      return this.$store.state.application.meta.hasAttemptToSubmit
    }
  },
  methods: {
    isSectionDisabled(id) {
      return false
    },
    isSectionVisible(section) {
      if(section.id === 'shelter'){
      const service = this.$store.state.application.services.type
      if (service && service.find(item => item === 'rentMortgage' || item === 'securityDeposit')) {
          return service.find(item => item === 'rentMortgage' || item === 'securityDeposit') .length > 0       
      }
     }else{
      return  true
      }
     },
    setFinalDeclarer(declarer) {
      const finalDeclarer = declarer || ''

      let today = new Date()
      let dd = today.getDate()

      let mm = today.getMonth() + 1
      const yyyy = today.getFullYear()
      if (dd < 10) {
        dd = `0${dd}`
      }

      if (mm < 10) {
        mm = `0${mm}`
      }

      // `clientName_1` is reserved for client declaring the form as accurate
      this.$store.dispatch('set', [
        'application.clientName_1',
        finalDeclarer
      ])
      this.$store.dispatch('set', ['application.hasClientDeclaration', true])
      this.$store.dispatch('set', [
        'application.clientDeclarationDate',
        `${yyyy}-${mm}-${dd}`
      ])
    },
    clearFinalDeclarer() {
      this.$store.dispatch('set', ['application.clientName_1', ''])
      this.$store.dispatch('set', ['application.hasClientDeclaration', false])
      this.$store.dispatch('set', ['application.clientDeclarationDate', ''])
    }
  },
  mounted() {
    this.$store.commit('set', ['auth.isUserActive', true])
    this.$store.commit('set', ['auth.isUserActiveTime', new Date().getTime()])


    //if no declarer or the declarer does not match what's set in the store (e.g. because they were removed)
    //then clear declarer variables in store
    if (
      !this.declarer ||
      (this.declarer &&
        this.$store.state.application.clientName_1 !==
          this.declarer)
    ) {
      this.clearFinalDeclarer()
    }
  }
}
</script>
